import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import moment from "moment/moment";
import { Calendar as PCalendar } from 'primereact/calendar';
import axios from "axios";

const PayrollexportFormComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({month: null});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const targetUrl = props.type === 'daily' 
      ? '/api/v2/export/daily_work_summary' 
      : '/api/v2/export/monthly_work_summary';
    const payload = {
      month: formData.month ? moment(formData.month).format('YYYY-MM') : null
    }
    apiCall('post', targetUrl, payload)
      .then(response => {
        window.App.toastShow('success', 'Sikeres export indítás!');
        window.App.setState({ rerenderPayrollexportList: Math.random() });
        form.restart();
      })
      .finally(() => setLoading(false));
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().payrollexportId) || (entity === 'payroll' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/export/monthly_work_summary' + (window.App.urlVars().payrollexportId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"payrollexport-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="month" render={({meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="month">{t('selectMonth')}</label>
                  <span className="p-d-block">
                    <PCalendar 
                      id="month"
                      locale='hu'
                      value={formData.month} 
                      onChange={(e) => setFormData({ ...formData, month: e.value })}
                      view={'month'}
                      dateFormat={'yy-mm'}
                      showIcon 
                      readOnlyInput 
                      className={classNames({'p-invalid': !!(meta.touched && meta.error)})}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'payroll' &&
                <Button type="submit" label="Exportálás"
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              {/* <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/> */}
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PayrollexportFormComponent);
